import { LearnerProfileDetailsFragment } from '@/modules/learner/views/LearnerProfile/graphql/fragments/generated/LearnerProfileDetails';
import { OnLearnerProfileAction } from '@/modules/learner/views/LearnerProfile/hooks/useLearnerProfile/actions';
import { ReportMetadataType } from '@/modules/report/hooks/useReportMetadata/types';
import { ReportEditorChartWidgetTypeFragment } from '@/modules/report/views/ReportEditor/graphql/fragments/generated/ReportEditorChartWidgetType';
import { Maybe, WidgetLayoutType } from '@/types/schema';

export enum EmployeeProfilePages {
  Mgsa = 'mgsa',
  Overview = 'overview',
  Activities = 'activities',
  Skills = 'skills',
  Mindsets = 'mindsets',
  Goals = 'goals',
  Team = 'team',
  Achievements = 'achievements',
  Leaderboard = 'leaderboard',
  About = 'about',
  Certificates = 'certificates',
  Content = 'content',
  Sessions = 'sessions',
  OneOnOne = 'one-on-one',
}

// NOTE: Please update the name of this type and its corresopnding field everywhere
// if the scope expands beyond AI Recommendations
export type AiRecommendationFilterPreset =
  | 'userViewingSelf'
  | 'userViewingMyTeam'
  | 'userViewingReportee';

export type EmployeeProfileWidgetProps = {
  user: LearnerProfileDetailsFragment;
  isCurrentUser: boolean;
  showHeader?: boolean;
  learner?: Maybe<LearnerProfileDetailsFragment>;
  isMobile?: boolean;
};

export interface EmployeeProfileWidgetPropsWithMetadata extends EmployeeProfileWidgetProps {
  reportAttributes: ReportMetadataType;
  aiRecommendationFilterPreset?: AiRecommendationFilterPreset;
}

export type EmployeeProfileWidgetPropsWithOnAction = EmployeeProfileWidgetProps & {
  onAction: OnLearnerProfileAction;
  readOnly?: boolean;
  isMobile?: boolean;
};

export type EmployeeProfileDetailsProps = {
  userId: string;
  type?: EmployeeProfilePages;
};

export interface UserProfileWidgetProps {
  chart: ReportEditorChartWidgetTypeFragment;
  reportAttributes: ReportMetadataType;
  user: LearnerProfileDetailsFragment;
  widgetLayout: WidgetLayoutType;
  setToCenter?: boolean;
  isDefaultRestricted?: boolean;
}
